import { BaseIconButton, Props as BaseIconButtonProps } from './BaseIconButton';

export type Props = BaseIconButtonProps & {
  color?:
    | 'icon-alt'
    | 'icon-ghost'
    | 'icon-primary'
    | 'icon-primary-dark'
    | 'icon-tertiary'
    | 'icon-secondary'
    | 'icon-secondary-dark';
  size?: Exclude<BaseIconButtonProps['size'], 'compact'>;
};

/**
 * `IconButton`s are `Buttons` that render `Icon`s within them for compact spaces.
 * They accept most props that `Button` accepts, although they'll always be `isSquare={true}`.
 *
 * Additionally, `IconButton` renders a `Tooltip` which describes what the `Button` does, which is important for accessibility.
 *
 * @deprecated Use `IconButton` instead. `LegacyIconButton` will be removed in a future release.
 */
export function LegacyIconButton({
  color = 'icon-primary',
  size = 'small',
  tooltipPosition = 'south',
  ...props
}: Props) {
  return (
    <BaseIconButton
      color={color}
      size={size}
      tooltipPosition={tooltipPosition}
      {...props}
    />
  );
}
